module.exports = __webpack_public_path__ + "img/shop-tmall.e1add731.png";